export default __webpack_public_path__ + "static/media/cbff0545103ce20d7b59be7d9c2d40b6662ad602cc8acdd1616380a5f43ff650.bdb123c1.svg";